module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('em', [_vm._v("“One of the Most Dangerous Men"), _c('br'), _vm._v("in Arkansas")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CONTINGENT OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXAS HORSE SOLDIERS, GRIMY, DUST")]), _vm._v(" covered, and heavily armed, arrived at Des Arc, Arkansas, in early 1862. “Riding far in advance on a magnificent chestnut sorrel, known to his proud owner as "), _c('em', [_vm._v("Limber Jim")]), _vm._v(", and leaning forward in an huge saddle that almost obscured its occupant, sat an innocent looking man of barely twenty-one years,” noted one writer. “His long tawny hair, which hung far below his shoulders, was crowned with a sombrero of unusual proportions, the brim, adorned with small bells that jingled with each motion of the horse’s gait. Securely fastened about the crown [of his bridle], as though with a garland of withered ivy, glistened the scales of a Texas rattler.”"), _c('a', {
    attrs: {
      "id": "ren28"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en28",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man was Howell Rayburn. Friends knew him by a nickname attributed to a childhood disease: “Yellow Doc,” or simply “Doc.”"), _c('a', {
    attrs: {
      "id": "ren29"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en29",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" His enemies called him “Banditti” or “Bandit.” A biographer pronounced him “one of the most dangerous men in Arkansas.”"), _c('a', {
    attrs: {
      "id": "ren30"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en30",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" One physical feature conveyed his deadly nature perhaps better than any other: “His blue eyes seemed at times to have lost every vestige of tenderness, compassion and mercy, especially for those who differed with his views.” It may have been this dark side of his character that contributed to one historian’s statement that “he was often accused of committing depredations on friends as well as foes.”"), _c('a', {
    attrs: {
      "id": "ren31"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en31",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc grew up in a farming family of nomadic habits. He lived in four states during his first ten years: from his birthplace in Tennessee, the Rayburns moved to Georgia, then Alabama before settling in Texas about 1849. He appears to have been orphaned before 1860."), _c('a', {
    attrs: {
      "id": "ren32"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en32",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" The following year, he and his younger brother Milton enlisted as privates in a company that joined the Twelfth Texas Cavalry. Milton later deserted."), _c('a', {
    attrs: {
      "id": "ren33"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en33",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" Doc also left the regiment—but not by choice.")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Howell A. Rayburn, Independent Guerrilla Command")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Carte de visite")]), _vm._v(" by unidentified photographer, about 1864–1866. Lawrence T. Jones III collection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After arriving at Des Arc, he fell ill with tuberculosis. A local woman nursed him back to health. His recovery took almost a year. During that time, while the Twelfth campaigned in that "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("part of Arkansas, between the White and Mississippi rivers, Union forces moved into the area, trapping him behind enemy lines."), _c('a', {
    attrs: {
      "id": "ren34"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en34",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" Doc determined to fight on, and he raised a cavalry company. His activities attracted the attention of Confederate colonel Thomas H. McCray, who took an interest in the young man and used his influence to help. Union intelligence reported that the company became McCray’s bodyguard."), _c('a', {
    attrs: {
      "id": "ren35"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en35",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" Doc’s recruits were adventurous boys whom he had befriended in Des Arc. He inspired about fifty to enlist, and he became their captain. Together, they rode on a string of lightning-quick raids against Yankee wagon trains in central Arkansas. His command became known as the “Phantom Unit” for its ability to appear out of nowhere and pounce on unsuspecting federals. On occasion, Doc took advantage of his long hair and girlish looks to dress as a woman so he could enter and spy on enemy camps."), _c('a', {
    attrs: {
      "id": "ren36"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en36",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" Union high command tried to capture Doc Rayburn and his guerrillas, but their efforts failed."), _c('a', {
    attrs: {
      "id": "ren37"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en37",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" At some point he sat for his "), _c('em', [_vm._v("carte de visite")]), _vm._v(" portrait (his name is misspelled “Reyborne” on the "), _c('em', [_vm._v("carte)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doc survived the war but did not live long afterwards. Accounts of his death vary. One source notes that “after peace had been declared one of the Confederate soldiers, who hated Rayburn, slipped back and shot him one evening just at sun down. He lived about twenty minutes after he was shot.” According to another source, U.S. authorities imprisoned him for wartime guerrilla activities, and his tuberculosis returned. Friends obtained his release on the basis that he would not live long. He died in 1865 and received a burial in the vicinity of Des Arc. The exact location of his gravesite is unknown. A simple headboard that soon decayed may have marked his final resting place. His wife, Martha Ann, whom he married in the summer of 1865, survived him. His horse, Limber Jim, was sold at a government auction and died of disease soon after."), _c('a', {
    attrs: {
      "id": "ren38"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#en38",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0016-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("2nd Lt. John McKinley Gibson, Company A, Thirteenth Louisiana Infantry")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Carte de visite")]), _vm._v(" by W. J. Carpenter (life dates unknown) & James Mullen (life dates unknown) of Lexington, Kentucky, about 1864–1865. David Wynn Vaughan collection.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57722966","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 99
// module chunks = 0